import Grid, { GridSize } from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { kebabCase } from "lodash";

import { useAppSelector } from "app/hooks";
import { selectCurrentUser } from "features/auth/auth-slice";
import { WordRecognitionReport } from "services/types/reports.type";
import { useGetUserQuery } from "services/users";

import { PreviewSpeechWordRecognitionDataGroup } from "./components";

interface PreviewSpeechWordRecognitionWordRecognitionProps {
  title: string;
  data?: WordRecognitionReport | null;
  additionalData?: WordRecognitionReport | null;
  detailSize?: GridSize;
  wordListSize?: GridSize;
  titleSize?: GridSize;
  pb?: number;
  titleMb?: number;
}

export default function PreviewSpeechWordRecognitionWordRecognition({
  data,
  additionalData,
  title,
  detailSize,
  wordListSize,
  titleSize,
  pb = 5,
  titleMb = 3
}: PreviewSpeechWordRecognitionWordRecognitionProps) {
  const { palette } = useTheme();
  const currentUser = useAppSelector(selectCurrentUser);
  const { data: user } = useGetUserQuery(currentUser.id, {
    skip: !currentUser.id || currentUser.id === -1
  });

  const switchAudiogramOrientation = Boolean(
    user?.user_preferences?.reporting?.switch_audiogram_orientation
  );
  return (
    <Grid
      item
      container
      spacing={0}
      marginTop={1}
      sx={{ pb }}
      data-testid={`subgroup-${kebabCase(title)}`}
    >
      <Grid item container lg={12} sx={{ mb: titleMb }}>
        <Typography
          fontSize={24}
          lineHeight="28px"
          color={palette.previewSpeechWordRecognition.color}
        >
          {title}
        </Typography>
      </Grid>
      {switchAudiogramOrientation ? (
        <PreviewSpeechWordRecognitionDataGroup
          data={data?.rightEar}
          additionalData={additionalData?.rightEar}
          title="Right"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      ) : (
        <PreviewSpeechWordRecognitionDataGroup
          data={data?.leftEar}
          additionalData={additionalData?.leftEar}
          title="Left"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      )}

      <PreviewSpeechWordRecognitionDataGroup
        data={data?.binaural}
        additionalData={additionalData?.binaural}
        title="Binaural"
        detailSize={detailSize}
        wordListSize={wordListSize}
        titleSize={titleSize}
      />
      {switchAudiogramOrientation ? (
        <PreviewSpeechWordRecognitionDataGroup
          data={data?.leftEar}
          additionalData={additionalData?.leftEar}
          title="Left"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      ) : (
        <PreviewSpeechWordRecognitionDataGroup
          data={data?.rightEar}
          additionalData={additionalData?.rightEar}
          title="Right"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      )}
    </Grid>
  );
}
